import { Injectable } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { map, Observable, of, startWith, switchMap } from 'rxjs';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { QuestionBankService } from './question-bank.service';
import { SnackbarService } from '../services/snackbar.service';
import { UploadContext } from '../interface/dto';
import { UploadQuestionsComponent } from '../exam-layout/operations/upload-questions/upload-questions.component';

@Injectable({
  providedIn: 'root'
})
export class QuestionBankOperationService {
  opOpen$: Observable<boolean> = of(false);

  constructor(
    private popoverService: PopoverService,
    private router: Router,
    private serializer: UrlSerializer,
    private questionBankService: QuestionBankService,
    private snackBar: SnackbarService
  ) { }

  async processQuestionBankOperation(route: any, origin: any) {
    if (this.questionBankService.selectedQuestionBanks?.length > 1) {
      this.snackBar.warning('Multiple Question Banks Selected');
      return;
    }

    // Upload questions operation
    if (route == 'operations/questions-bank/question/upload') {
      this.openModal(origin, UploadQuestionsComponent, UploadContext.QuestionBank);
      return;
    }
  }

  public openModal(origin: any, _classtype: any, context?: UploadContext) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: _classtype,
        origin,
        width: 2000,
        offsetY: 12,
        data: { context }, 
        position: [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  public operationQuestionBankList() {
    return [
      {
        icon: 'mat:cloud_upload',
        label: 'Import Questions',
        route: 'operations/questions-bank/question/upload',
        id: 'questionbank_import_questions'
      }
    ];
  }
}
